const EmployeesTrainedByLocation = (function () {
  const state = {
    allLocations: [],
    locations: [],
    filters: {
      vendor: {
        text: 'All',
        value: '%',
      },
      region: {
        text: 'All',
        value: '%',
      },
      location: {
        text: 'All',
        value: '%',
      },
      employee: {
        text: 'All',
        value: '%',
      },
      status: {
        text: 'All',
        value: '%',
      },
    },
  };

  let pageDiv;
  let tableMarkup;
  let reqVisualizer;

  // Filter
  //---------------------------------------------------------------
  let filterBtn;
  let vendorBtnWrap, vendorBtn, vendorCloseBtn;
  let regionBtnWrap, regionBtn, regionCloseBtn;
  let locationBtnWrap, locationBtn, locationCloseBtn;
  let employeeBtnWrap, employeeBtn, employeeCloseBtn;
  let statusBtnWrap, statusBtn, statusCloseBtn;

  let vendorDropdown, regionDropdown, locationDropdown, employeeDropdown, statusDropdown;
  let tempVendor, tempRegion, tempLocation, tempEmployee, tempStatus;

  // filtered by display
  function buildCurrentFilterdisplay() {
    const currentFilterDisplay = _DOM.createElement('div', { class: 'filteredByData' });
    const filteredByWrap = _DOM.createElement('div', { class: 'filteredByWrap' });
    const btnWrap = _DOM.createElement('div', { class: 'filterBtnWrap' });

    vendorBtnWrap = _DOM.createElement('div', { class: 'filterSelectionBtnWrap' });
    regionBtnWrap = _DOM.createElement('div', { class: 'filterSelectionBtnWrap' });
    locationBtnWrap = _DOM.createElement('div', { class: 'filterSelectionBtnWrap' });
    employeeBtnWrap = _DOM.createElement('div', { class: 'filterSelectionBtnWrap' });
    statusBtnWrap = _DOM.createElement('div', { class: 'filterSelectionBtnWrap' });

    filterBtn = button.build({
      text: 'Filter',
      icon: 'filter',
      style: 'secondary',
      type: 'contained',
      classNames: 'filterBtnNew',
      callback: () => {
        showFilterPopup('ALL');
      },
    });

    vendorBtn = button.build({
      id: 'vendorBtn',
      text: 'Vendor:',
      style: 'secondary',
      type: 'text',
      classNames: 'filterSelectionBtn',
      callback: () => {
        showFilterPopup('vendorBtn');
      },
    });
    vendorCloseBtn = button.build({
      icon: 'Delete',
      style: 'secondary',
      type: 'text',
      classNames: 'filterCloseBtn',
      callback: () => {
        closeFilter('vendorBtn');
      },
    });

    regionBtn = button.build({
      id: 'regionBtn',
      text: 'Region:',
      style: 'secondary',
      type: 'text',
      classNames: 'filterSelectionBtn',
      callback: () => {
        showFilterPopup('regionBtn');
      },
    });
    regionCloseBtn = button.build({
      icon: 'Delete',
      style: 'secondary',
      type: 'text',
      classNames: 'filterCloseBtn',
      callback: () => {
        closeFilter('regionBtn');
      },
    });

    locationBtn = button.build({
      id: 'locationBtn',
      text: 'Location:',
      style: 'secondary',
      type: 'text',
      classNames: 'filterSelectionBtn',
      callback: () => {
        showFilterPopup('locationBtn');
      },
    });
    locationCloseBtn = button.build({
      icon: 'Delete',
      style: 'secondary',
      type: 'text',
      classNames: 'filterCloseBtn',
      callback: () => {
        closeFilter('locationBtn');
      },
    });

    employeeBtn = button.build({
      id: 'employeeBtn',
      text: 'Employee:',
      style: 'secondary',
      type: 'text',
      classNames: 'filterSelectionBtn',
      callback: () => {
        showFilterPopup('employeeBtn');
      },
    });
    employeeCloseBtn = button.build({
      icon: 'Delete',
      style: 'secondary',
      type: 'text',
      classNames: 'filterCloseBtn',
      callback: () => {
        closeFilter('employeeBtn');
      },
    });

    statusBtn = button.build({
      id: 'statusBtn',
      text: 'Status:',
      style: 'secondary',
      type: 'text',
      classNames: 'filterSelectionBtn',
      callback: () => {
        showFilterPopup('statusBtn');
      },
    });
    statusCloseBtn = button.build({
      icon: 'Delete',
      style: 'secondary',
      type: 'text',
      classNames: 'filterCloseBtn',
      callback: () => {
        closeFilter('statusBtn');
      },
    });

    vendorBtnWrap.appendChild(vendorBtn);
    vendorBtnWrap.appendChild(vendorCloseBtn);

    regionBtnWrap.appendChild(regionBtn);
    regionBtnWrap.appendChild(regionCloseBtn);

    locationBtnWrap.appendChild(locationBtn);
    locationBtnWrap.appendChild(locationCloseBtn);

    employeeBtnWrap.appendChild(employeeBtn);
    employeeBtnWrap.appendChild(employeeCloseBtn);

    statusBtnWrap.appendChild(statusBtn);
    statusBtnWrap.appendChild(statusCloseBtn);

    btnWrap.appendChild(filterBtn);

    filteredByWrap.appendChild(btnWrap);
    filteredByWrap.appendChild(vendorBtnWrap);
    filteredByWrap.appendChild(regionBtnWrap);
    filteredByWrap.appendChild(locationBtnWrap);
    filteredByWrap.appendChild(employeeBtnWrap);
    filteredByWrap.appendChild(statusBtnWrap);

    currentFilterDisplay.appendChild(filteredByWrap);

    return currentFilterDisplay;
  }
  function updateCurrentFilterDisplay(
    vendor = '%',
    region = '%',
    location = '%',
    employee = '%',
    status = '%',
  ) {
    if (vendor === '%' || vendor === 'All') {
      vendorBtnWrap.classList.add('hidden');
    } else {
      vendorBtnWrap.classList.remove('hidden');
      vendorBtn.textContent = `Vendor: ${vendor}`;
    }

    if (region === '%' || region === 'All') {
      regionBtnWrap.classList.add('hidden');
    } else {
      regionBtnWrap.classList.remove('hidden');
      regionBtn.textContent = `Region: ${region}`;
    }

    if (location === '%' || location === 'All') {
      locationBtnWrap.classList.add('hidden');
    } else {
      locationBtnWrap.classList.remove('hidden');
      locationBtn.textContent = `Location: ${location}`;
    }

    if (employee === '%' || employee === 'All') {
      employeeBtnWrap.classList.add('hidden');
    } else {
      employeeBtnWrap.classList.remove('hidden');
      employeeBtn.textContent = `Employee: ${employee}`;
    }

    if (status === '%' || status === 'All') {
      statusBtnWrap.classList.add('hidden');
    } else {
      statusBtnWrap.classList.remove('hidden');
      statusBtn.textContent = `Status: ${status}`;
    }
  }
  // filter popup
  function filterLocationData() {
    const hasEmployeeFilter = state.filters.employee.value !== '%';
    const hasStatusFilter = state.filters.status.value !== '%';

    return state.allLocations
      .filter(locationItem => {
        if (
          String(locationItem.vendorId) !== String(state.filters?.vendor.value) &&
          state.filters?.vendor.value !== '%'
        ) {
          return false;
        }

        if (
          String(locationItem.regionId) !== String(state.filters?.region.value) &&
          state.filters?.region.value !== '%'
        ) {
          return false;
        }

        if (
          String(locationItem.locationId) !== String(state.filters?.location.value) &&
          state.filters?.location.value !== '%'
        ) {
          return false;
        }

        return true;
      })
      .map(locationItem => {
        if (!hasEmployeeFilter && !hasStatusFilter) {
          return locationItem;
        }

        const filteredEmployees = (locationItem.employees || []).filter(employeeItem => {
          if (
            String(employeeItem.personId) !== String(state.filters?.employee.value) &&
            state.filters?.employee.value !== '%'
          ) {
            return false;
          }

          if (
            employeeItem.status !== state.filters?.status.value &&
            state.filters?.status.value !== '%'
          ) {
            return false;
          }

          return true;
        });

        return {
          ...locationItem,
          employees: filteredEmployees,
        };
      })
      .filter(locationItem => {
        if (!hasEmployeeFilter && !hasStatusFilter) {
          return true;
        }

        return (locationItem.employees || []).length > 0;
      });
  }
  function applyFilter() {
    updateCurrentFilterDisplay(
      state.filters.vendor.text,
      state.filters.region.text,
      state.filters.location.text,
      state.filters.employee.text,
      state.filters.status.text,
    );

    repopulateTable();
  }
  function closeFilter(closefilter) {
    if (closefilter == 'vendorBtn') {
      state.filters.vendor.text = 'All';
      state.filters.vendor.value = '%';
    }
    if (closefilter == 'regionBtn') {
      state.filters.region.text = 'All';
      state.filters.region.value = '%';
    }
    if (closefilter == 'locationBtn') {
      state.filters.location.text = 'All';
      state.filters.location.value = '%';
    }
    if (closefilter == 'employeeBtn') {
      state.filters.employee.text = 'All';
      state.filters.employee.value = '%';
    }
    if (closefilter == 'statusBtn') {
      state.filters.status.text = 'All';
      state.filters.status.value = '%';
    }

    applyFilter();
  }

  function populateVendorDropdown(defaultValue = '%') {
    const dropdownData = state.vendors.map(reg => {
      return {
        text: reg.description,
        value: reg.vendorId,
      };
    });

    dropdownData.unshift({ text: 'All', value: '%' });

    dropdown.populate(vendorDropdown, dropdownData, defaultValue);
  }
  async function populateRegionDropdownByVendorId(vendorId, defaultValue) {
    input.disableInputField(regionDropdown);

    const resp = (
      await _UTIL.fetchData('getEmployeesTrainedRegionDropdownData', {
        vendorId: vendorId === '%' ? null : vendorId,
      })
    ).GetEmployeesTrainedRegionDropdownDataResult;

    const dropdownData = resp.map(reg => {
      return {
        text: reg.description,
        value: reg.regionId,
      };
    });

    const hasDefault = dropdownData.some(item => String(item.value) === String(defaultValue));
    tempRegion = hasDefault ? tempRegion : { text: 'All', value: '%' };

    dropdownData.unshift({ text: 'All', value: '%' });
    input.enableInputField(regionDropdown);
    dropdown.populate(regionDropdown, dropdownData, hasDefault ? defaultValue : '%');
  }
  async function populateLocationDroopdownByRegionId(vendorId, regionId, defaultValue) {
    input.disableInputField(locationDropdown);

    const resp = (
      await _UTIL.fetchData('getEmployeesTrainedLocationDropdownData', {
        userId: $.session.UserId,
        vendorId: vendorId === '%' ? null : vendorId,
        regionId: regionId === '%' ? null : regionId,
      })
    ).GetEmployeesTrainedLocationDropdownDataResult;

    const dropdownData = resp.map(loc => {
      return {
        text: loc.description,
        value: loc.locationId,
      };
    });

    const hasDefault = dropdownData.some(item => String(item.value) === String(defaultValue));
    tempLocation = hasDefault ? tempLocation : { text: 'All', value: '%' };

    dropdownData.unshift({ text: 'All', value: '%' });
    input.enableInputField(locationDropdown);
    dropdown.populate(locationDropdown, dropdownData, hasDefault ? defaultValue : '%');
  }
  async function populateEmployeeDropdownByLocationId(
    vendorId,
    regionId,
    locationId,
    defaultValue,
  ) {
    input.disableInputField(employeeDropdown);

    const resp = (
      await _UTIL.fetchData('getEmployeesTrainedEmployeeDropdownData', {
        vendorId: vendorId === '%' ? null : vendorId,
        regionId: regionId === '%' ? null : regionId,
        locationId: locationId === '%' ? null : locationId,
      })
    ).GetEmployeesTrainedEmployeeDropdownDataResult;

    const dropdownData = resp.map(emp => {
      return {
        text: emp.employee,
        value: emp.personId,
      };
    });

    const hasDefault = dropdownData.some(item => String(item.value) === String(defaultValue));
    tempEmployee = hasDefault ? tempEmployee : { text: 'All', value: '%' };

    dropdownData.unshift({ text: 'All', value: '%' });
    input.enableInputField(employeeDropdown);
    dropdown.populate(employeeDropdown, dropdownData, hasDefault ? defaultValue : '%');
  }
  function populateStatusDropdown(defaultValue = '%') {
    const dropdownData = [{ value: '%', text: 'All' }, ...state.status];
    dropdown.populate(statusDropdown, dropdownData, defaultValue);
  }

  async function showFilterPopup(IsShow) {
    tempVendor = { ...state.filters.vendor };
    tempRegion = { ...state.filters.region };
    tempLocation = { ...state.filters.location };
    tempEmployee = { ...state.filters.employee };
    tempStatus = { ...state.filters.status };

    const filterPopup = POPUP.build({
      closeCallback: () => {},
    });

    vendorDropdown = dropdown.build({
      label: 'Vendor',
      dropdownId: 'trainedByLocationVendorDropdown',
    });
    regionDropdown = dropdown.build({
      label: 'Region',
      dropdownId: 'trainedByLocationRegionDropdown',
    });
    locationDropdown = dropdown.build({
      label: 'Location',
      dropdownId: 'trainedByLocationLocationDropdown',
    });
    employeeDropdown = dropdown.build({
      label: 'Employee',
      dropdownId: 'trainedByLocationEmployeeFilterDropdown',
    });
    statusDropdown = dropdown.build({
      label: 'Status',
      dropdownId: 'trainedByLocationStatusFilterDropdown',
    });

    const applyButton = button.build({
      text: 'Apply',
      style: 'secondary',
      type: 'contained',
    });
    applyButton.classList.add('singleBtn');

    vendorDropdown.addEventListener('change', async event => {
      const selectedOption = event.target.options[event.target.selectedIndex];
      tempVendor = {
        text: selectedOption.text,
        value: selectedOption.value,
      };

      if (IsShow.toLowerCase() !== 'all') return;

      await populateRegionDropdownByVendorId(tempVendor.value, tempRegion.value);
      await populateLocationDroopdownByRegionId(
        tempVendor.value,
        tempRegion.value,
        tempLocation.value,
      );
      await populateEmployeeDropdownByLocationId(
        tempVendor.value,
        tempRegion.value,
        tempLocation.value,
        tempEmployee.value,
      );
    });
    regionDropdown.addEventListener('change', async event => {
      const selectedOption = event.target.options[event.target.selectedIndex];
      tempRegion = {
        text: selectedOption.text,
        value: selectedOption.value,
      };

      if (IsShow.toLowerCase() !== 'all') return;

      await populateLocationDroopdownByRegionId(
        tempVendor.value,
        tempRegion.value,
        tempLocation.value,
      );
      await populateEmployeeDropdownByLocationId(
        tempVendor.value,
        tempRegion.value,
        tempLocation.value,
        tempEmployee.value,
      );
    });
    locationDropdown.addEventListener('change', async event => {
      const selectedOption = event.target.options[event.target.selectedIndex];
      tempLocation = {
        text: selectedOption.text,
        value: selectedOption.value,
      };

      if (IsShow.toLowerCase() !== 'all') return;

      await populateEmployeeDropdownByLocationId(
        tempVendor.value,
        tempRegion.value,
        tempLocation.value,
        tempEmployee.value,
      );
    });
    employeeDropdown.addEventListener('change', event => {
      const selectedOption = event.target.options[event.target.selectedIndex];
      tempEmployee = {
        text: selectedOption.text,
        value: selectedOption.value,
      };
    });
    statusDropdown.addEventListener('change', event => {
      const selectedOption = event.target.options[event.target.selectedIndex];
      tempStatus = {
        text: selectedOption.text,
        value: selectedOption.value,
      };
    });

    applyButton.addEventListener('click', () => {
      state.filters.vendor = tempVendor ?? state.filters.vendor;
      state.filters.region = tempRegion ?? state.filters.region;
      state.filters.location = tempLocation ?? state.filters.location;
      state.filters.employee = tempEmployee ?? state.filters.employee;
      state.filters.status = tempStatus ?? state.filters.status;

      applyFilter();

      POPUP.hide(filterPopup);
    });

    if (IsShow == 'ALL' || IsShow == 'vendorBtn') {
      filterPopup.appendChild(vendorDropdown);
      populateVendorDropdown(tempVendor.value);
    }
    if (IsShow == 'ALL' || IsShow == 'regionBtn') {
      filterPopup.appendChild(regionDropdown);
    }
    if (IsShow == 'ALL' || IsShow == 'locationBtn') {
      filterPopup.appendChild(locationDropdown);
    }
    if (IsShow == 'ALL' || IsShow == 'employeeBtn') {
      filterPopup.appendChild(employeeDropdown);
    }
    if (IsShow == 'ALL' || IsShow == 'statusBtn') {
      filterPopup.appendChild(statusDropdown);
      populateStatusDropdown(tempStatus.value);
    }

    if (IsShow == 'ALL') {
      await populateRegionDropdownByVendorId(tempVendor.value, tempRegion.value);
      await populateLocationDroopdownByRegionId(
        tempVendor.value,
        tempRegion.value,
        tempLocation.value,
      );
      await populateEmployeeDropdownByLocationId(
        tempVendor.value,
        tempRegion.value,
        tempLocation.value,
        tempEmployee.value,
      );
    } else {
      if (IsShow == 'regionBtn') {
        await populateRegionDropdownByVendorId(tempVendor.value, tempRegion.value);
      }
      if (IsShow == 'locationBtn') {
        await populateLocationDroopdownByRegionId(
          tempVendor.value,
          tempRegion.value,
          tempLocation.value,
        );
      }
      if (IsShow == 'employeeBtn') {
        await populateEmployeeDropdownByLocationId(
          tempVendor.value,
          tempRegion.value,
          tempLocation.value,
          tempEmployee.value,
        );
      }
    }

    filterPopup.appendChild(applyButton);

    POPUP.show(filterPopup);
  }

  // Employee Trained Tool
  //---------------------------------------------------------------
  async function assignEmployeesToTrainedLocations(assignments) {
    const resp = (
      await _UTIL.fetchData('AssignEmployeesToTrainedLocations', {
        assignments: assignments,
      })
    ).AssignEmployeesToTrainedLocationsResult;

    return resp;
  }
  function filterEmployeeTrainedToolList(listElement, query, emptyMessage) {
    if (!listElement) return;

    const normalizedQuery = String(query || '')
      .trim()
      .toLowerCase();
    const rows = Array.from(listElement.querySelectorAll('.employeeTrainedToolListRow'));

    let emptyState = listElement.querySelector('.employeeTrainedToolEmptyState');
    if (!emptyState) {
      emptyState = document.createElement('p');
      emptyState.classList.add('employeeTrainedToolEmptyState');
      emptyState.hidden = true;
      listElement.appendChild(emptyState);
    }

    let visibleCount = 0;

    rows.forEach(row => {
      const text = String(row.textContent || '')
        .trim()
        .toLowerCase();
      const matches = !normalizedQuery || text.includes(normalizedQuery);

      row.style.display = matches ? '' : 'none';

      if (matches) {
        visibleCount += 1;
      }
    });

    emptyState.textContent = emptyMessage;
    emptyState.hidden = visibleCount > 0;
  }
  function buildSearchInput(searchFor, onSearchCallback) {
    const wrap = document.createElement('div');
    wrap.classList.add('customSearch');

    const searchBtn = button.build({
      id: `searchBtn${searchFor}`,
      text: 'Search',
      icon: 'search',
      style: 'secondary',
      type: 'contained',
      callback: () => {
        wrap.classList.toggle('searchOpen');
        searchInput.value = '';
        searchInput.focus();
      },
    });

    const searchInput = document.createElement('input');
    searchInput.setAttribute('placeholder', `search ${searchFor}`);
    searchInput.addEventListener('keyup', event => {
      if (event.key === 'Enter') {
        onSearchCallback(event.target.value);
      }
    });
    searchInput.addEventListener('input', event => {
      if (event.target.value === '') {
        onSearchCallback(event.target.value);
      }
    });

    wrap.appendChild(searchBtn);
    wrap.appendChild(searchInput);

    return wrap;
  }
  function buildLocationList() {
    const locationList = document.createElement('div');
    locationList.classList.add('employeeTrainedToolList');

    state.activeLocations.forEach(loc => {
      const row = document.createElement('p');
      row.classList.add('employeeTrainedToolListRow');
      row.id = loc.locationId;
      row.textContent = loc.description;
      locationList.append(row);
    });

    return locationList;
  }
  function buildEmployeeList() {
    const employeeList = document.createElement('div');
    employeeList.classList.add('employeeTrainedToolList');

    state.activeEmployees.forEach(emp => {
      const row = document.createElement('p');
      row.classList.add('employeeTrainedToolListRow');
      row.id = emp.personId;
      row.textContent = emp.employee;
      employeeList.append(row);
    });

    return employeeList;
  }
  function showEmployeeTrainedToolPopup() {
    const selectedLocations = new Set();
    const selectedEmployees = new Set();
    let status = 'Y';

    let selectAllLocationsActive = false;
    let selectAllEmployeesActive = false;

    const popup = POPUP.build({
      id: 'employeeTrainedToolPopup',
      header: 'Assign Employees to Locations',
      classNames: ['employeeTrainedToolPopup'],
    });

    // locations
    //-------------------------------------------------
    const locationSearchBtn = buildSearchInput('location', searchValue => {
      filterEmployeeTrainedToolList(locationList, searchValue, 'No matching locations found.');
    });
    const locationSelectAllBtn = button.build({
      text: 'Select All Locations',
      style: 'secondary',
      type: 'contained',
      classNames: 'selectAllBtn',
      callback: () => {
        selectAllLocationsActive = !selectAllLocationsActive;

        const rows = locationList.querySelectorAll('.employeeTrainedToolListRow');
        rows.forEach(row => {
          if (!selectAllLocationsActive) {
            locationSelectAllBtn.textContent = 'Select All Locations';
            locationSelectAllBtn.classList.remove('active');
            row.classList.remove('is-selected');
            selectedLocations.delete(row.id);
          } else {
            locationSelectAllBtn.textContent = 'Unselect All Locations';
            locationSelectAllBtn.classList.add('active');
            row.classList.add('is-selected');
            selectedLocations.add(row.id);
          }
        });

        const hasSelections = selectedLocations.size > 0 && selectedEmployees.size > 0;
        assignBtn.classList.toggle('disabled', !hasSelections);
      },
    });
    const locationList = buildLocationList();
    locationList.addEventListener('click', e => {
      if (!e.target.classList.contains('employeeTrainedToolListRow')) return;

      const id = e.target.id;

      if (selectedLocations.has(id)) {
        selectedLocations.delete(id);
        e.target.classList.remove('is-selected');
      } else {
        selectedLocations.add(id);
        e.target.classList.add('is-selected');
      }

      const hasSelections = selectedLocations.size > 0 && selectedEmployees.size > 0;
      assignBtn.classList.toggle('disabled', !hasSelections);

      if (selectedLocations.size === state.activeLocations.length) {
        selectAllLocationsActive = true;
        locationSelectAllBtn.textContent = 'Unselect All Locations';
      } else {
        selectAllLocationsActive = false;
        locationSelectAllBtn.textContent = 'Select All Locations';
      }
    });

    // employees
    //-------------------------------------------------
    const employeeSearchBtn = buildSearchInput('employee', searchValue => {
      filterEmployeeTrainedToolList(employeeList, searchValue, 'No matching employees found.');
    });
    const employeeSelectAllBtn = button.build({
      text: 'Select All Employees',
      style: 'secondary',
      type: 'contained',
      classNames: 'selectAllBtn',
      callback: () => {
        selectAllEmployeesActive = !selectAllEmployeesActive;

        const rows = employeeList.querySelectorAll('.employeeTrainedToolListRow');
        rows.forEach(row => {
          if (!selectAllEmployeesActive) {
            employeeSelectAllBtn.textContent = 'Select All Employees';
            employeeSelectAllBtn.classList.remove('active');
            row.classList.remove('is-selected');
            selectedEmployees.delete(row.id);
          } else {
            employeeSelectAllBtn.textContent = 'Unselect All Employees';
            employeeSelectAllBtn.classList.add('active');
            row.classList.add('is-selected');
            selectedEmployees.add(row.id);
          }
        });

        const hasSelections = selectedLocations.size > 0 && selectedEmployees.size > 0;
        assignBtn.classList.toggle('disabled', !hasSelections);
      },
    });
    const employeeList = buildEmployeeList();
    employeeList.addEventListener('click', e => {
      if (!e.target.classList.contains('employeeTrainedToolListRow')) return;

      const id = e.target.id;

      if (selectedEmployees.has(id)) {
        selectedEmployees.delete(id);
        e.target.classList.remove('is-selected');
      } else {
        selectedEmployees.add(id);
        e.target.classList.add('is-selected');
      }

      const hasSelections = selectedLocations.size > 0 && selectedEmployees.size > 0;
      assignBtn.classList.toggle('disabled', !hasSelections);

      if (selectedEmployees.size === state.activeEmployees.length) {
        selectAllEmployeesActive = true;
        employeeSelectAllBtn.textContent = 'Unselect All Employees';
      } else {
        selectAllEmployeesActive = false;
        employeeSelectAllBtn.textContent = 'Select All Employees';
      }
    });

    // other
    //-------------------------------------------------
    const statusDropdown = dropdown.build({
      dropdownId: 'employeeTrainedToolStatusDropdown',
      label: 'Status',
      style: 'secondary',
      callback: e => {
        const selectedOption = e.target.options[e.target.selectedIndex];
        status = selectedOption.value;
      },
    });
    const assignBtn = button.build({
      text: 'Assign',
      style: 'secondary',
      type: 'contained',
      callback: async () => {
        if (assignBtn.classList.contains('disabled')) return;

        reqVisualizer.show('Assigning Employee(s) to Location(s)...');
        const combinations = [];

        for (const locationId of selectedLocations) {
          for (const employeeId of selectedEmployees) {
            combinations.push({
              locationId,
              employeeId,
              status: status,
              userId: $.session.UserId,
            });
          }
        }

        const resp = await assignEmployeesToTrainedLocations(combinations);

        if (resp) {
          repopulateTable();
          reqVisualizer.fullfill('success', 'Employees Assigned', 1000);
        } else {
          reqVisualizer.fullfill('error', 'Error assigning employee(s) to location(s).', 1000);
        }

        POPUP.hide(popup);
      },
    });
    const cancelBtn = button.build({
      text: 'Cancel',
      style: 'secondary',
      type: 'contained',
      callback: () => {
        POPUP.hide(popup);
      },
    });

    // state
    //-------------------------------------------------
    assignBtn.classList.add('disabled');

    // Build
    //-------------------------------------------------
    const note = document.createElement('p');
    note.classList.add('employeeTrainedToolPopupNote');
    note.textContent =
      '*Must select at least one location and one employee before clicking Assign button.';

    const columns = document.createElement('div');
    columns.classList.add('employeeTrainedToolColumns');

    const locationColumn = document.createElement('div');
    locationColumn.classList.add('employeeTrainedToolColumn');

    const employeeColumn = document.createElement('div');
    employeeColumn.classList.add('employeeTrainedToolColumn');

    const locationLabel = document.createElement('div');
    locationLabel.classList.add('employeeTrainedToolLabel');
    locationLabel.textContent = 'Select at least one location';

    const employeeLabel = document.createElement('div');
    employeeLabel.classList.add('employeeTrainedToolLabel');
    employeeLabel.textContent = 'Select at least one employee';

    locationColumn.appendChild(locationLabel);
    locationColumn.appendChild(locationSearchBtn);
    locationColumn.appendChild(locationList);
    locationColumn.appendChild(locationSelectAllBtn);

    employeeColumn.appendChild(employeeLabel);
    employeeColumn.appendChild(employeeSearchBtn);
    employeeColumn.appendChild(employeeList);
    employeeColumn.appendChild(employeeSelectAllBtn);

    columns.appendChild(locationColumn);
    columns.appendChild(employeeColumn);

    const buttonWrap = document.createElement('div');
    buttonWrap.classList.add('employeeTrainedToolActions');

    buttonWrap.appendChild(assignBtn);
    buttonWrap.appendChild(cancelBtn);

    popup.appendChild(note);
    popup.appendChild(columns);
    popup.appendChild(statusDropdown);
    popup.appendChild(buttonWrap);

    dropdown.populate(statusDropdown, state.status, status);

    POPUP.show(popup);
  }

  // Add New Employee
  //---------------------------------------------------------------
  async function addEmployeeToTrainedLocation(locationId, employeeId, status) {
    const resp = (
      await _UTIL.fetchData('AddEmployeeToTrainedLocation', {
        userId: $.session.UserId,
        locationId: locationId,
        employeeId: employeeId,
        status: status,
      })
    ).AddEmployeeToTrainedLocationResult;

    return resp;
  }
  function populateActiveEmployeeDropdown(dropdownEle) {
    const dropdownData = state.activeEmployees.map(emp => {
      return {
        value: emp.personId,
        text: emp.employee,
      };
    });

    dropdownData.unshift({
      value: '',
      text: '',
    });

    dropdown.populate(dropdownEle, dropdownData);
  }
  async function populateEmployeeDetailsTable(employeeId, detailsTable) {
    table.clear(detailsTable);

    if (!employeeId) {
      return [];
    }

    const resp = (
      await _UTIL.fetchData('getEmployeesTrainedSelectedEmployeeData', {
        employeeId: employeeId,
      })
    ).GetEmployeesTrainedSelectedEmployeeDataResult;

    const tableData = resp.map(td => {
      return {
        id: 'employeeDetailsTable',
        values: [td.dataSubcategory, td.effectiveDate, td.expirationDate],
      };
    });

    table.populate(detailsTable, tableData);
    return resp;
  }
  function showAddNewEmployeePopup(locationId) {
    return new Promise(resolve => {
      let selectedEmployeeId,
        selectedStatus = 'Y',
        selectedEmployeeData = [];

      const location = state.locations.find(
        location => String(location.locationId) === String(locationId),
      );
      const locationName = location?.location || 'Location';

      const popup = POPUP.build({
        id: 'trainedByLocationAddEmployeePopup',
        header: `Add Employee to ${locationName}`,
      });

      // Form
      //---------------------------------------------------
      const formWrap = document.createElement('div');
      formWrap.classList.add('addNewEmployeeForm');

      const employeeDropdown = dropdown.build({
        dropdownId: 'trainedByLocationEmployeeDropdown',
        label: 'Employee',
        style: 'secondary',
        callback: async e => {
          const selectedOption = e.target.options[e.target.selectedIndex];
          selectedEmployeeId = selectedOption.value;
          const requestedEmployeeId = selectedEmployeeId;
          selectedEmployeeData = [];

          if (!selectedEmployeeId) {
            saveBtn.classList.add('disabled');
            employeeDropdown.classList.add('error');
          } else {
            saveBtn.classList.add('disabled');
            employeeDropdown.classList.remove('error');
          }

          const employeeData = await populateEmployeeDetailsTable(
            selectedEmployeeId,
            employeeDetailsTable,
          );

          if (selectedEmployeeId === requestedEmployeeId) {
            selectedEmployeeData = employeeData;
            saveBtn.classList.remove('disabled');
          }
        },
      });
      const statusDropdown = dropdown.build({
        dropdownId: 'trainedByLocationStatusDropdown',
        label: 'Status',
        style: 'secondary',
        callback: e => {
          const selectedOption = e.target.options[e.target.selectedIndex];
          selectedStatus = selectedOption.value;
        },
      });

      const saveBtn = button.build({
        text: 'Save',
        style: 'secondary',
        type: 'contained',
        callback: async () => {
          if (saveBtn.classList.contains('disabled')) return;

          POPUP.hide(popup);
          resolve({
            employeeId: selectedEmployeeId,
            status: selectedStatus,
            employeeData: selectedEmployeeData,
          });
        },
      });
      const cancelBtn = button.build({
        text: 'Cancel',
        style: 'secondary',
        type: 'outlined',
        callback: () => {
          POPUP.hide(popup);
          resolve(false);
        },
      });

      // Form
      //---------------------------------------------------
      const employeeDetailsTable = table.build({
        tableId: 'employeeDetailsTable',
        columnHeadings: ['Data Subcategory', 'Effective Date', 'Expiration Date'],
        callback: event => {},
      });

      // Initial State
      //---------------------------------------------------
      employeeDropdown.classList.add('error');
      saveBtn.classList.add('disabled');

      populateActiveEmployeeDropdown(employeeDropdown);
      dropdown.populate(statusDropdown, state.status, 'Y');

      // Build
      //---------------------------------------------------
      const buttonWrap = document.createElement('div');
      buttonWrap.classList.add('btnWrap');
      buttonWrap.appendChild(saveBtn);
      buttonWrap.appendChild(cancelBtn);

      formWrap.appendChild(employeeDropdown);
      formWrap.appendChild(statusDropdown);
      formWrap.appendChild(buttonWrap);

      popup.appendChild(formWrap);
      popup.appendChild(employeeDetailsTable);

      POPUP.show(popup);
    });
  }

  // Table
  //---------------------------------------------------------------
  function escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
  function setButtonExpandedState(button, isExpanded) {
    button.setAttribute('aria-expanded', String(isExpanded));
    button.classList.toggle('is-expanded', isExpanded);
  }
  function collapseNestedAccordions(container) {
    const expandedButtons = container.querySelectorAll('.caret-button[aria-expanded="true"]');

    expandedButtons.forEach(button => {
      setButtonExpandedState(button, false);

      const targetId = button.getAttribute('aria-controls');
      const detailRow = targetId ? container.querySelector(`#${CSS.escape(targetId)}`) : null;

      if (detailRow) {
        detailRow.hidden = true;
      }
    });
  }
  function attachAccordionBehavior(markup) {
    const table = markup.querySelector('.trained-by-location-table');

    if (!table) {
      return;
    }

    table.addEventListener('click', event => {
      const button = event.target.closest('.caret-button[data-toggle]');

      if (!button) {
        return;
      }

      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      const nextState = !isExpanded;
      const targetId = button.getAttribute('aria-controls');
      const detailRow = targetId ? markup.querySelector(`#${CSS.escape(targetId)}`) : null;

      setButtonExpandedState(button, nextState);

      if (!detailRow) {
        return;
      }

      detailRow.hidden = !nextState;

      if (!nextState) {
        collapseNestedAccordions(detailRow);
      }
    });
  }
  //
  function doesEmployeeMatchActiveFilters(employeeRecord, selectedStatus) {
    const employeeFilterValue = state.filters.employee.value;
    const statusFilterValue = state.filters.status.value;

    if (
      employeeFilterValue !== '%' &&
      String(employeeRecord.personId) !== String(employeeFilterValue)
    ) {
      return false;
    }

    if (statusFilterValue !== '%' && String(selectedStatus) !== String(statusFilterValue)) {
      return false;
    }

    return true;
  }
  function appendEmployeeRowToLocation(locationId, employeeId, selectedStatus, employeeData = []) {
    const normalizedLocationId = String(locationId);
    const normalizedEmployeeId = String(employeeId);
    const detailContainer = tableMarkup.querySelector(
      `.location-detail-container-row[data-location-id="${normalizedLocationId}"]`,
    );

    if (!detailContainer) return false;

    const employeeTableBody = detailContainer.querySelector('.tier-two-table tbody');
    if (!employeeTableBody) return false;

    const existingRow = employeeTableBody.querySelector(
      `.employee-row[data-employee-id="${normalizedEmployeeId}"]`,
    );
    if (existingRow) return true;

    const employeeRecord = state.activeEmployees.find(
      emp => String(emp.personId) === normalizedEmployeeId,
    );
    if (!employeeRecord) return false;

    const locationRecord = state.locations.find(
      location => String(location.locationId) === normalizedLocationId,
    );
    const allLocationRecord = state.allLocations.find(
      location => String(location.locationId) === normalizedLocationId,
    );

    const savedStatus = selectedStatus;
    const isActive = savedStatus === 'Y';
    const activeClass = isActive ? 'active' : 'inactive';
    const statusIcon = isActive ? icons.thumbUp : icons.thumbDown;
    const detailRowId = `employee-details-${normalizedLocationId}-${normalizedEmployeeId}`;
    const employeeName = String(employeeRecord.employee || '').trim();

    if (locationRecord) {
      if (!Array.isArray(locationRecord.employees)) {
        locationRecord.employees = [];
      }

      locationRecord.employees.push({
        personId: employeeRecord.personId,
        employee: employeeRecord.employee,
        status: savedStatus,
        employeeData,
      });
    }
    if (allLocationRecord && allLocationRecord !== locationRecord) {
      if (!Array.isArray(allLocationRecord.employees)) {
        allLocationRecord.employees = [];
      }

      allLocationRecord.employees.push({
        personId: employeeRecord.personId,
        employee: employeeRecord.employee,
        status: savedStatus,
        employeeData,
      });
    }

    // Do not inject a DOM row that the active employee/status filters would hide.
    if (!doesEmployeeMatchActiveFilters(employeeRecord, savedStatus)) {
      return true;
    }

    const emptyPlaceholderRow = employeeTableBody.querySelector(
      '.employee-row[data-employee-id=""]',
    );
    const emptyPlaceholderDetailRow = employeeTableBody.querySelector(
      '.employee-detail-container-row[data-employee-id=""]',
    );
    if (emptyPlaceholderRow) emptyPlaceholderRow.remove();
    if (emptyPlaceholderDetailRow) emptyPlaceholderDetailRow.remove();

    const rowMarkup = `
      <tr
        class="employee-row tier-two-row"
        data-location-id="${normalizedLocationId}"
        data-employee-id="${normalizedEmployeeId}"
      >
        <td></td>
        <td class="caret-cell">
          <button
            type="button"
            class="caret-button"
            data-toggle="employee"
            data-employee-id="${normalizedEmployeeId}"
            aria-expanded="false"
            aria-controls="${detailRowId}"
            aria-label="Expand employee details"
          >
            ${icons.keyArrowDown}
          </button>
        </td>
        <td class="employee-name-cell">${escapeHtml(employeeName)}</td>
        <td class="status-cell">
          <button
            type="button"
            class="status-button"
            data-action="status"
            data-status="${activeClass}"
            data-location-id="${normalizedLocationId}"
            data-employee-id="${normalizedEmployeeId}"
            aria-label="Update employee status"
          >
            <span class="status-placeholder ${activeClass}">${statusIcon}</span>
          </button>
        </td>
        <td class="action-cell">
          <button
            type="button"
            class="action-button"
            data-action="delete"
            data-location-id="${normalizedLocationId}"
            data-employee-id="${normalizedEmployeeId}"
            aria-label="Delete record"
          >
            <span class="delete-placeholder">${icons.delete}</span>
          </button>
        </td>
      </tr>
      <tr
        id="${detailRowId}"
        class="employee-detail-container-row tier-two-detail-row"
        data-location-id="${normalizedLocationId}"
        data-employee-id="${normalizedEmployeeId}"
        hidden
      >
        <td colspan="5" class="nested-table-cell">
          ${buildDetailRows(employeeData, normalizedLocationId, normalizedEmployeeId)}
        </td>
      </tr>
    `;

    const employeeRows = Array.from(employeeTableBody.querySelectorAll('.employee-row'));
    const insertBeforeRow = employeeRows.find(row => {
      const currentName = String(
        row.querySelector('.employee-name-cell')?.textContent || '',
      ).trim();

      if (!currentName) return false;

      return (
        employeeName.localeCompare(currentName, undefined, {
          sensitivity: 'base',
          numeric: true,
        }) < 0
      );
    });

    if (insertBeforeRow) {
      insertBeforeRow.insertAdjacentHTML('beforebegin', rowMarkup);
    } else {
      employeeTableBody.insertAdjacentHTML('beforeend', rowMarkup);
    }

    return true;
  }
  function updateEmployeeStatusInLocationState(locationId, employeeId, newStatus) {
    const normalizedLocationId = String(locationId);
    const normalizedEmployeeId = String(employeeId);

    const updateCollection = locations => {
      if (!Array.isArray(locations)) return;

      const locationRecord = locations.find(
        location => String(location.locationId) === normalizedLocationId,
      );
      if (!locationRecord || !Array.isArray(locationRecord.employees)) return;

      const employeeRecord = locationRecord.employees.find(
        employee => String(employee.personId) === normalizedEmployeeId,
      );
      if (!employeeRecord) return;

      employeeRecord.status = newStatus;
    };

    updateCollection(state.locations);
    updateCollection(state.allLocations);
  }
  function removeEmployeeFromLocationState(locationId, employeeId) {
    const normalizedLocationId = String(locationId);
    const normalizedEmployeeId = String(employeeId);

    const removeFromCollection = locations => {
      if (!Array.isArray(locations)) return;

      const locationRecord = locations.find(
        location => String(location.locationId) === normalizedLocationId,
      );
      if (!locationRecord || !Array.isArray(locationRecord.employees)) return;

      locationRecord.employees = locationRecord.employees.filter(
        employee => String(employee.personId) !== normalizedEmployeeId,
      );
    };

    removeFromCollection(state.locations);
    removeFromCollection(state.allLocations);
  }
  async function syncLocationRowAfterEmployeeMutation(locationId) {
    const normalizedLocationId = String(locationId);

    state.locations = filterLocationData();

    const filteredLocation = filterLocationData().find(
      location => String(location.locationId) === normalizedLocationId,
    );

    const locationRow = tableMarkup.querySelector(
      `.location-row[data-location-id="${normalizedLocationId}"]`,
    );
    const detailRow = tableMarkup.querySelector(
      `.location-detail-container-row[data-location-id="${normalizedLocationId}"]`,
    );

    if (!filteredLocation) {
      locationRow?.remove();
      detailRow?.remove();
      return;
    }

    if (!locationRow || !detailRow) {
      await repopulateTable();
      return;
    }

    const wasExpanded =
      locationRow
        .querySelector('.caret-button[data-toggle="location"]')
        ?.getAttribute('aria-expanded') === 'true';

    const employeeRowIds = new Set(
      Array.from(detailRow.querySelectorAll('.employee-row[data-employee-id]')).map(row =>
        String(row.getAttribute('data-employee-id')),
      ),
    );
    const expandedEmployeeIds = new Set(
      Array.from(
        detailRow.querySelectorAll('.employee-row .caret-button[aria-expanded="true"]'),
      ).map(button => String(button.getAttribute('data-employee-id'))),
    );

    const rebuiltDetailMarkup = buildEmployeeRows(filteredLocation.employees, normalizedLocationId);
    const nestedCell = detailRow.querySelector('.nested-table-cell');
    if (nestedCell) {
      nestedCell.innerHTML = rebuiltDetailMarkup;
    }

    if (wasExpanded) {
      detailRow.hidden = false;
      const locationCaret = locationRow.querySelector('.caret-button[data-toggle="location"]');
      if (locationCaret) {
        setButtonExpandedState(locationCaret, true);
      }
    }

    expandedEmployeeIds.forEach(employeeId => {
      if (!employeeRowIds.has(employeeId)) return;

      const employeeButton = detailRow.querySelector(
        `.employee-row[data-employee-id="${employeeId}"] .caret-button[data-toggle="employee"]`,
      );
      const employeeDetailRow = detailRow.querySelector(
        `.employee-detail-container-row[data-employee-id="${employeeId}"]`,
      );

      if (employeeButton && employeeDetailRow) {
        setButtonExpandedState(employeeButton, true);
        employeeDetailRow.hidden = false;
      }
    });
  }
  //
  async function repopulateTable() {
    reqVisualizer.show('Reloading Table...');

    const employeesResp = await _UTIL.fetchData('getEmployeesTrained', {
      userId: $.session.UserId,
    });

    state.allLocations = employeesResp.GetEmployeesTrainedResult.locations || [];
    state.locations = filterLocationData();

    const newTableMarkup = buildTable(state.locations);
    tableMarkup.remove();
    pageDiv.append(newTableMarkup);

    tableMarkup = newTableMarkup;

    attachAccordionBehavior(tableMarkup);
    attachActionListeners(tableMarkup);

    reqVisualizer.fullfill('success', '', 500);
  }
  function buildDetailRows(details = [], locationId, employeeId) {
    const detailItems =
      Array.isArray(details) && details.length
        ? details
        : [{ dataSubcategory: '', effectiveDate: '', expirationDate: '' }];

    const rows = detailItems
      .map(
        detailItem => `
        <tr class="detail-row">
          <td></td>
          <td></td>
          <td class="detail-name-cell">
            ${
              escapeHtml(detailItem.dataSubcategory).trim() ||
              '<span class="empty-cell">No data</span>'
            }
          </td>
          <td>${
            escapeHtml(detailItem.effectiveDate).trim() || '<span class="empty-cell">-</span>'
          }</td>
          <td>${
            escapeHtml(detailItem.expirationDate).trim() || '<span class="empty-cell">-</span>'
          }</td>
        </tr>
      `,
      )
      .join('');

    return `
    <table
      class="nested-table tier-three-table"
      data-location-id="${locationId}"
      data-employee-id="${employeeId}"
    >
      <colgroup>
        <col class="empty-column"/>
        <col class="empty-column"/>
        <col class="primary-column-three" />
        <col class="secondary-column-three" />
        <col class="tertiary-column-three" />
      </colgroup>
      <thead>
        <tr class="section-header detail-header-row">
          <th></th>
          <th></th>
          <th>Data Subcategory</th>
          <th>Effective Date</th>
          <th>Expiration Date</th>
        </tr>
      </thead>
      <tbody>
        ${rows}
      </tbody>
    </table>
  `;
  }
  function buildEmployeeRows(employees = [], locationId) {
    // const employeeItems =
    //   Array.isArray(employees) && employees.length
    //     ? employees
    //     : [{ personId: '', employee: '', status: '', employeeData: [] }];

    const employeeItems = employees;

    const rows = employeeItems
      .map(employeeItem => {
        const employeeId = employeeItem.personId;
        const isActive = employeeItem.status === 'Y';
        const activeClass = isActive ? 'active' : 'inactive';
        const statusIcon = isActive ? icons.thumbUp : icons.thumbDown;
        const emptyCell = '<span class="empty-cell"></span>';
        const detailRowId = `employee-details-${locationId}-${employeeId || 'empty'}`;

        return `
          <tr
            class="employee-row tier-two-row"
            data-location-id="${locationId}"
            data-employee-id="${employeeId}"
          >
            <td></td>
            <td class="caret-cell">
              <button
                type="button"
                class="caret-button"
                data-toggle="employee"
                data-employee-id="${employeeId}"
                aria-expanded="false"
                aria-controls="${detailRowId}"
                aria-label="Expand employee details"
              >
                ${icons.keyArrowDown}
              </button>
            </td>
            <td class="employee-name-cell">${
              escapeHtml(employeeItem.employee).trim() || emptyCell
            }</td>
            <td class="status-cell">
              <button
                type="button"
                class="status-button"
                data-action="status"
                data-status="${activeClass}"
                data-location-id="${locationId}"
                data-employee-id="${employeeId}"
                aria-label="Update employee status"
              >
                <span class="status-placeholder ${activeClass}">${statusIcon}</span>
              </button>
            </td>
            <td class="action-cell">
              <button
                type="button"
                class="action-button"
                data-action="delete"
                data-location-id="${locationId}"
                data-employee-id="${employeeId}"
                aria-label="Delete record"
              >
                <span class="delete-placeholder">${icons.delete}</span>
              </button>
            </td>
          </tr>
          <tr
            id="${detailRowId}"
            class="employee-detail-container-row tier-two-detail-row"
            data-location-id="${locationId}"
            data-employee-id="${employeeId}"
            hidden
          >
            <td colspan="5" class="nested-table-cell">
              ${buildDetailRows(employeeItem.employeeData, locationId, employeeId)}
            </td>
          </tr>
        `;
      })
      .join('');

    return `
      <table class="nested-table tier-two-table" data-location-id="${locationId}">
        <colgroup>
          <col class="empty-column"/>
          <col class="caret-column" />
          <col class="primary-column-two" />
          <col class="secondary-column-two" />
          <col class="action-column" />
        </colgroup>
        <thead>
          <tr class="section-header employee-header-row">
            <th class="blank-header"></th>
            <th class="blank-header"></th>
            <th>Employee</th>
            <th class="status-header">Status</th>
            <th class="blank-header"></th>
          </tr>
        </thead>
        <tbody>
          ${rows}
        </tbody>
      </table>
    `;
  }
  function buildTable(data = []) {
    const markup = document.createElement('div');

    const rows = data
      .filter(item => item.location != null)
      .sort((a, b) => a.location.localeCompare(b.location))
      .map(locationItem => {
        const locationId = locationItem.locationId;
        const emptyCell = '<span class="empty-cell"></span>';
        const employeeRowId = `location-details-${locationId}`;

        const hasEmployees = locationItem.employees.length > 0;

        return `
          <tr class="location-row" data-location-id="${locationId}">
            <td class="caret-cell">
              <button
                type="button"
                class="caret-button"
                data-toggle="location"
                data-location-id="${locationId}"
                aria-expanded="false"
                aria-controls="${employeeRowId}"
                aria-label="Expand location details"
              >
                ${icons.keyArrowDown}
              </button>
            </td>

            <td>${escapeHtml(locationItem.location).trim() || emptyCell}</td>
            <td>${escapeHtml(locationItem.vendor).trim() || emptyCell}</td>
            <td>${escapeHtml(locationItem.region).trim() || emptyCell}</td>

            <td class="action-cell">
              <button
                type="button"
                class="action-button add-button"
                data-action="add"
                data-location-id="${locationId}"
                aria-label="Add record"
              >
                <span class="add-placeholder">${icons.add}</span>
              </button>
            </td>
          </tr>
          <tr
            id="${employeeRowId}"
            class="location-detail-container-row tier-one-detail-row"
            data-location-id="${locationId}"
            hidden
          >
            <td colspan="5" class="nested-table-cell">
              ${buildEmployeeRows(locationItem.employees, locationId)}
            </td>
          </tr>
        `;
      })
      .join('');

    markup.innerHTML = `
      <table class="trained-by-location-table">
        <colgroup>
          <col class="caret-column" />
          <col class="primary-column" />
          <col class="secondary-column" />
          <col class="tertiary-column" />
          <col class="action-column" />
        </colgroup>
        <thead>
          <tr class="section-header">
            <th class="blank-header"></th>
            <th>Location</th>
            <th>Vendor</th>
            <th>Region</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          ${rows}
        </tbody>
      </table>
    `;

    return markup;
  }

  // table events
  async function handleAddClick(button) {
    const locationId = button.getAttribute('data-location-id');
    const newEmployeeData = await showAddNewEmployeePopup(locationId);

    if (!newEmployeeData) return;

    reqVisualizer.show('Adding New Employee...');
    const { employeeId, status, employeeData } = newEmployeeData;
    const resp = await addEmployeeToTrainedLocation(locationId, employeeId, status);

    if (resp.success !== true) {
      reqVisualizer.fullfill('error', resp.message, 1000);
      return;
    }

    reqVisualizer.fullfill('success', 'Employee Added', 1000);

    const appended = appendEmployeeRowToLocation(locationId, employeeId, status, employeeData);

    if (!appended || state.filters.employee.value !== '%' || state.filters.status.value !== '%') {
      await repopulateTable();
    }
  }
  async function handleStatusClick(button) {
    reqVisualizer.show('Updating Employee Status...');

    const locationId = button.getAttribute('data-location-id');
    const employeeId = button.getAttribute('data-employee-id');
    const currentStatus = button.getAttribute('data-status');
    const newStatus = currentStatus === 'active' ? 'D' : 'Y';
    const newActiveClass = newStatus === 'Y' ? 'active' : 'inactive';

    const resp = (
      await _UTIL.fetchData('UpdateEmployeeTrainedPreferred', {
        updateValue: newStatus,
        locationId: locationId,
        employeeId: employeeId,
      })
    ).UpdateEmployeeTrainedPreferredResult;

    if (resp) {
      updateEmployeeStatusInLocationState(locationId, employeeId, newStatus);

      button.classList.remove(currentStatus);
      button.classList.add(newActiveClass);
      button.setAttribute('data-status', newActiveClass);
      button.innerHTML = `
        <span class="status-placeholder ${newActiveClass}">
          ${newStatus === 'Y' ? icons.thumbUp : icons.thumbDown}
        </span>
      `;

      await syncLocationRowAfterEmployeeMutation(locationId);
      reqVisualizer.fullfill('success', 'Employee Status Updated', 1000);
    } else {
      reqVisualizer.fullfill('error', 'Error updating employee status.', 1000);
    }
  }
  function showDeleteWarning() {
    return new Promise(resolve => {
      const popup = POPUP.build({
        id: 'deleteEmployeeWarningPopup',
      });

      const message = document.createElement('p');
      message.textContent = 'Are you sure you want to remove this employee from this location?';

      const closeAndResolve = value => {
        POPUP.hide(popup);
        resolve(value);
      };

      const saveBtn = button.build({
        text: 'Yes',
        style: 'secondary',
        type: 'contained',
        callback: () => closeAndResolve(true),
      });
      const cancelBtn = button.build({
        text: 'No',
        style: 'secondary',
        type: 'outlined',
        callback: () => closeAndResolve(false),
      });

      const buttonWrap = document.createElement('div');
      buttonWrap.classList.add('btnWrap');

      buttonWrap.append(saveBtn);
      buttonWrap.append(cancelBtn);

      popup.append(message);
      popup.append(buttonWrap);

      POPUP.show(popup);
    });
  }
  async function handleDeleteClick(button) {
    const locationId = button.getAttribute('data-location-id');
    const employeeId = button.getAttribute('data-employee-id');

    const deleteEmployee = await showDeleteWarning();

    if (!deleteEmployee) return;

    reqVisualizer.show('Deleting Employee...');
    const resp = (
      await _UTIL.fetchData('DeleteEmployeeFromTrainedLocation', {
        locationId: locationId,
        employeeId: employeeId,
      })
    ).DeleteEmployeeFromTrainedLocationResult;

    if (resp) {
      removeEmployeeFromLocationState(locationId, employeeId);

      // button.parentElement.parentElement.remove();
      // document.getElementById(`employee-details-${locationId}-${employeeId}`)?.remove();

      await syncLocationRowAfterEmployeeMutation(locationId);
      reqVisualizer.fullfill('success', 'Employee Deleted', 1000);
    } else {
      reqVisualizer.fullfill('error', 'There was an error deleting this employee.', 1000);
    }
  }
  function attachActionListeners(markup) {
    const table = markup.querySelector('.trained-by-location-table');

    table.addEventListener('click', event => {
      const button = event.target.closest('[data-action]');

      if (!button) {
        return;
      }

      const action = button.getAttribute('data-action');

      if (action === 'status') {
        handleStatusClick(button);
        return;
      }

      if (action === 'add') {
        handleAddClick(button);
        return;
      }

      if (action === 'delete') {
        handleDeleteClick(button);
      }
    });
  }

  // Main
  //---------------------------------------------------------------
  function buildPage() {
    pageDiv = document.createElement('div');

    const toolbar = document.createElement('div');
    toolbar.classList.add('trainedByLocationToolbar');

    const toolbarActions = document.createElement('div');
    toolbarActions.classList.add('trainedByLocationToolbarActions');

    const filterDisplay = buildCurrentFilterdisplay();

    const employeeTrainedToolBtn = button.build({
      text: 'Employee Trained Tool',
      style: 'secondary',
      type: 'contained',
      callback: () => {
        showEmployeeTrainedToolPopup();
      },
    });

    toolbarActions.appendChild(employeeTrainedToolBtn);
    toolbar.appendChild(toolbarActions);
    toolbar.appendChild(filterDisplay);

    tableMarkup = buildTable(state.locations);
    attachAccordionBehavior(tableMarkup);
    attachActionListeners(tableMarkup);

    pageDiv.appendChild(toolbar);
    pageDiv.appendChild(tableMarkup);

    DOM.clearActionCenter();
    DOM.ACTIONCENTER.appendChild(pageDiv);

    updateCurrentFilterDisplay();
  }
  async function init() {
    const [employeesResp, dropdownResp] = await Promise.all([
      _UTIL.fetchData('getEmployeesTrained', { userId: $.session.UserId }),
      _UTIL.fetchData('getEmployeesTrainedDropdownData', { userId: $.session.UserId }),
    ]);

    state.allLocations = employeesResp.GetEmployeesTrainedResult.locations || [];
    state.locations = state.allLocations;
    state.activeEmployees = dropdownResp.GetEmployeesTrainedDropdownDataResult.employees || [];
    state.activeLocations = dropdownResp.GetEmployeesTrainedDropdownDataResult.locations || [];
    state.vendors = dropdownResp.GetEmployeesTrainedDropdownDataResult.vendors || [];
    state.status = [
      { value: 'Y', text: 'Preferred' },
      { value: 'D', text: 'Not Preferred' },
    ];

    buildPage();

    reqVisualizer = new AsyncRequestVisualizer();
    reqVisualizer.renderTo(_DOM.ACTIONCENTER);
  }

  return {
    init,
  };
})();
